import { render, staticRenderFns } from "./DetalleEvento.vue?vue&type=template&id=ab830de6&scoped=true"
import script from "./DetalleEvento.vue?vue&type=script&lang=js"
export * from "./DetalleEvento.vue?vue&type=script&lang=js"
import style0 from "./DetalleEvento.vue?vue&type=style&index=0&id=ab830de6&prod&scoped=true&lang=css"
import style1 from "./DetalleEvento.vue?vue&type=style&index=1&id=ab830de6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab830de6",
  null
  
)

export default component.exports